export const isAdmin = (userRoles: any) => {
	return userRoles?.some((role: any) => (role.name === 'admin' || role === 'ROLE_ADMIN'));
};